import React, { useMemo } from 'react'
import { Table } from '/src/components/common'

import './order_table.scss'

const buildTableColumns = () => {
  return [
    {
      Header: 'Date',
      accessor: 'placed'
    },
    {
      Header: 'Order ID',
      accessor: 'order_number'
    },
    {
      Header: 'Invoice ID',
      accessor: 'dsap_order_id'
    },
    {
      Header: 'Status',
      accessor: 'state'
    },
    {
      Header: 'PDF',
      accessor: 'pdf'
    }
  ]
}

// @todo, add pdf field.
const buildTableData = (orders) => {
  const allowed = [
    'placed',
    'order_number',
    'dsap_order_id',
    'state',
  ]

  console.log(orders)

  return orders.map(({ attributes }) => {
    const results = {}
    for (let [key, value] of Object.entries(attributes)) {
      if (allowed.includes(key)) {
        results[key] = value
      }
    }

    return results
  })
}

export const OrderTable = ({ orders }) => {
  const columns = useMemo(() => buildTableColumns(), [])
  const data = useMemo(() => buildTableData(orders), [orders])

  return <Table className="order-table" columns={columns} data={data} />
}

export default OrderTable
